import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.core').component('kissBuyerAutocompleteFilter', {
        bindings: {
            buyerSelected: '=',
            disable: '<'
        },
        controller: BuyerAutocompleteFilterController,
        templateUrl: require('./buyer-autocomplete-filter.html')
    });

    BuyerAutocompleteFilterController.$inject = ['PrincipalSvc'];

    function BuyerAutocompleteFilterController(PrincipalSvc) {
        var ctrl = this;

        ctrl.searchBuyers = searchBuyers;

        ctrl.$onInit = function() {
            if (!ctrl.disable) {
              ctrl.disable = false;
            }
        }

        /**
         * Recherche des clients en autocomplétion.
         */
        function searchBuyers(value) {
            if (value && value.length >= 3) {
                return PrincipalSvc.searchCompanies(value).then(function(companies) {
                    return companies;
                });
            }
        }
    }
})();
